<app-modal class="replace-tool-modal" [isLoading]="isLoading">
    <div class="modal-header" modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body" modal-body>
        <form [formGroup]="replaceToolForm">
            <div class="row">
                <div class="col s8 offset-s2">
                    <app-display-label
                        label="{{'atom.tool-requests-lines.replaceTools.modal.reasonForReplacement' | translate}}"
                        [value]="getTranslatedMessage(selectedTool?.reasonForReplacement)"
                        [valueStyle]="{'max-width': '100%'}"></app-display-label>
                </div>
            </div>
            <div class="row">
                <div class="col s8 offset-s2">
                    <app-display-label
                        label="{{'atom.tool-requests-lines.replaceTools.modal.selectedTool' | translate}}"
                        [value]="selectedTool?.compoundName"
                        [valueStyle]="{'max-width': '100%'}"></app-display-label>

                </div>
            </div>
            <div class="row" *ngIf="shouldRenderReplacer()">
                <div class="col s8 offset-s2">
                    <app-dropdown-autocomplete formControlName="selectedTool"
                                               [formControl]="replaceToolForm.controls['selectedTool']"
                                               [showErrors]="showValidations"
                                               [items]="replacementTools"
                                               name="selectedTool"
                                               valueField="id"
                                               displayField="compoundName"
                                               appendTo="body"
                                               [labelStyle]="{'color': '#808285','font-weight': '500', 'width': '200px', 'font-size': '17px'}"
                                               [label]="'atom.tool-requests-lines.replaceTools.modal.replacementTool' | translate"
                                               [emptyText]="'atom.tool-requests-lines.replaceTools.modal.placeholder' | translate"
                                               (selectItem)="onReplacementSelect($event)">
                    </app-dropdown-autocomplete>
                </div>
            </div>
            <div class="row" *ngIf="!shouldRenderReplacer()">
                <div class="col s8 offset-s2">
                    <app-alert type="error" [responsive]="true"
                               message="{{'atom.tool-requests-lines.replaceTools.modal.errors.noReplacementTools' | translate}}"></app-alert>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button
            *ngIf="hasCancel"
            type="simple"
            (click)="close()"
            [disabled]="isLoading"
            data-dismiss="modal">
            {{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button
            *ngIf="shouldRenderReplacer()"
            type="primary"
            [disabled]="isLoading"
            (click)="onConfirm()"
            data-dismiss="modal">
            {{ "generic.buttons.confirm" | translate }}
        </app-button>
        <app-button type="secondary"
                    (click)="onRepair()"
                    class="repair-tool">
            {{ "atom.tool-requests-lines.replaceTools.modal.repair" | translate }}
        </app-button>
    </div>
</app-modal>
